import http from "../http-common";

class ResultatsService {

    listFiltreAdminDireccioEnquesta(data){
        return http.post("/resultats/acumulats", data);
      }
}

export default new ResultatsService();